import * as React from 'react'
import { Tooltip } from 'antd'
import PropTypes from 'prop-types'

// badge wrappers for sub-components
import ActionPriorityBadge from "./ActionPriorityBadge/ActionPriorityBadge"
import ActionStatusBadge from "./ActionStatusBadge/ActionStatusBadge"
import AssessmentResultBadge from "./AssessmentResultBadge/AssessmentResultBadge"
import FileStatusBadge from "./FileStatusBadge/FileStatusBadge"
import RecruitmentBadge from "./RecruitmentBadge/RecruitmentBadge"
import RegistryBadge from "./RegistryBadge/RegistryBadge"
import StudyTypeBadge from "./StudyTypeBadge/StudyTypeBadge"
import PhaseBadge from "./PhaseBadge/PhaseBadge"
import WorkflowStatusBadge from "./WorkflowStatusBadge/WorkflowStatusBadge"

import './Badge.scss'

export const colorSchemes = ["indigo", "cyan", "yellow", "magenta", "fuchsia", "purple", "blue", "mint", "orange", "brown", "red", "lime", "green", "seafoam", "gray", "charcoal"]

const Badge = ({
  value = "...",
  colorName,
  tooltipText,
  size = "middle",
  isFlex, // set to true to wrap badge in a flex div that will prevent the badge to extend the full width of a cell in a grid
  className,
  style,
}) => {

  let classNames = ["prime-badge"]
  if (colorName) classNames.push(colorName)
  if (className) classNames.push(className)
  if (size) classNames.push(`prime-badge-${size}`)

  if (!value) return null;

  const content = <div
    style={{ ...style }}
    className={classNames.join(' ')}
  >
    {value}
  </div>

  return <Tooltip title={tooltipText}>
    {isFlex ? <div className="prime-badge-wrap">
      {content}
    </div> : content}
  </Tooltip>
}

// sub-component definitions for badge wrappers
Badge.ActionPriority = ActionPriorityBadge
Badge.ActionStatus = ActionStatusBadge
Badge.AssessmentResult = AssessmentResultBadge
Badge.FileStatus = FileStatusBadge
Badge.Phase = PhaseBadge
Badge.RecruitmentStatus = RecruitmentBadge
Badge.Registry = RegistryBadge
Badge.StudyType = StudyTypeBadge
Badge.WorkflowStatus = WorkflowStatusBadge

Badge.propTypes = {
  value: PropTypes.string,
  colorName: PropTypes.oneOf(colorSchemes),
  tooltipText: PropTypes.string,
  size: PropTypes.oneOf(["small", "middle", "large"]),
  isFlex: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Badge